import React from "react";
import Modal from "react-bootstrap/Modal";
import CustomFormInput from "../CustomFormInput";
import { formatDate } from "../../helper/common";

function EventViewModal({ show, handleClose, selectedEvent }) {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>View Event</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <CustomFormInput
          label="Event Name"
          value={selectedEvent?.eventName}
          disabled
        />
        <CustomFormInput
          label="Organizer"
          value={selectedEvent?.userId?.firstName + " " + selectedEvent?.userId?.lastName}
          disabled
        />
        <CustomFormInput
          label="Activity"
          value={selectedEvent?.activities?.map((activity) => activity.title).join(", ")}
          disabled
        />
        <CustomFormInput
          label="Skill"
          value={selectedEvent?.skill?.map((skill) => skill.name).join(", ") || '-'}
          disabled
        />
        <CustomFormInput
          label="Event Date"
          value={formatDate(selectedEvent?.eventDate)}
          disabled
        />
        <CustomFormInput
          label="Location"
          value={selectedEvent?.location}
          disabled
        />

        <CustomFormInput
          label="Event Type"
          value={selectedEvent?.eventType === 1 ? 'Public' : 'Private'}
          disabled
        />
        <CustomFormInput
          label="Community Name"
          value={selectedEvent?.communityId?.name}
          disabled
        />
        <CustomFormInput
          as="textarea"
          type="text"
          label="Description"
          value={selectedEvent?.description}
          disabled
        />

        <CustomFormInput
          label="Attendees"
          value={selectedEvent?.attendees?.map((activity) => activity.userName).join(", ")}
          disabled
        />
      </Modal.Body>
    </Modal>
  );
}

export default EventViewModal;
